import React from "react";
import { useTheme } from '@mui/material/styles';
import {
    Button, Typography, Box, Grid
} from "@mui/material";
import helpers from "../../../Helpers/Helpers";
import { DeleteForeverOutlined, Done, EditOutlined, Key } from "@mui/icons-material";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import CustomTable from "../../../shared/CustomTable";

export default function UsersView(props) {
    const theme = useTheme();

    const columns = [
        {
            field: 'org', headerName: 'Organization', valueFormatter: (params) => params?.value?.org_name, minWidth: 150, type: "singleSelect",
            valueOptions: props.organizations.map(x => ({ value: x._id, label: x.org_name })), filterable: true
        },
        { field: 'fname', headerName: props.literals.name, renderCell: (params) => (`${params.row.fname} ${params.row.lname}`), minWidth: 250, filterable: true },
        { field: 'email', headerName: props.literals.email, valueGetter: (params) => params.row?.email, minWidth: 200, filterable: true },
        { field: 'address', headerName: props.literals.address, valueGetter: (params) => params.row?.address, minWidth: 150, filterable: true },
        { field: 'phone_no', headerName: props.literals.phone_no, valueGetter: (params) => params.row?.mobile_no, minWidth: 200, filterable: true },
        { field: 'role', headerName: props.literals.role, valueGetter: (params) => (params.row.role === undefined) ? props.literals.user : props.literals[params.row.role] , minWidth: 150, filterable: false },
        { field: 'verified', headerName: props.literals.verified, valueGetter: (params) => (params.row.email_verified) ? 'Yes' : 'No', minWidth: 150, filterable: false },
        {
            field: 'edit-delete',
            headerName: props.literals.action,
            minWidth: 250,
            headerClassName: 'header',
            renderCell: (params) => (
                <>
                    <Button
                        type="button"
                        disabled={helpers.abilityByModuleKey('users').can_delete == false}
                        onClick={() => props.delItem(params.row._id)}
                        sx={{ color: '#bc0000', background: '#bc00002e', p: '2px', minWidth: 0, m: 1 }}
                    >
                        <DeleteForeverOutlined />
                    </Button>
                    <Button
                        type="button"
                        disabled={helpers.abilityByModuleKey('users').can_edit == false}
                        onClick={() => { props.onEdit(params.row) }}
                        sx={{ color: '#027c92', background: '#027c924d', p: '2px', minWidth: 0, m: 1 }}
                    >
                        <EditOutlined />
                    </Button>
                    <Button
                        type="button"
                        disabled={helpers.abilityByModuleKey('users').can_edit == false}
                        onClick={() => { props.passwordModel(params.row) }}
                        sx={{ color: '#dc9003', background: '#ffa50061', p: '2px', minWidth: 0, m: 1 }}
                    >
                        <Key />
                    </Button>
                    {!params.row.email_verified && <Button
                        type="button"
                        disabled={helpers.abilityByModuleKey('users').can_edit == false}
                        onClick={() => { props.onVerify(params.row) }}
                        sx={{ color: '#029225', background: '#0292254f', p: '2px', minWidth: 0, m: 1 }}
                    >
                        <Done />
                    </Button>}
                </>
            )
        },
    ]

    return (
        <Grid container spacing={3} sx={{ placeContent: "center", py: 2 }}>
            <Grid item xs={6}>
                <Typography variant="subtitle1" color="primary" className="font-bold font-gray"> {props.literals.users}</Typography>
            </Grid>
            <Grid item xs={6} align="right">
                <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    sx={{ minWidth: 110 }}
                    onClick={props.setOpenDrawer}
                    disabled={helpers.abilityByModuleKey('users').can_add == false}
                >
                    {props.literals.add} +
                </Button>
            </Grid>
            <Grid item xs={12}>
                <CustomTable
                    columns={columns}
                    data={props.users}

                    onPageChange={props.onPageChange}
                    onFilter={props.onFilter}
                    onSort={props.onSort}
                    onEdit={props.onEdit}
                    delItem={props.delItem}
                />
                {/* <Box
                    sx={{
                    height: '75vh',
                    width: '100%',
                    '& .header': {
                        backgroundColor: theme.palette.primary.main,
                        color: '#fff'
                    },
                    }}
                >
                    <DataGrid
                        getRowId={(row) => row._id}
                        rows={props.users }
                        columns={columns}
                        disableSelectionOnClick={true}
                        components={{ Toolbar: GridToolbar }} 
                        density={'compact'}
                    />
                </Box> */}
            </Grid>
        </Grid>
    );
}
